<app-loader [isLoading]="isLoading"></app-loader>

<div class="header">
    <div class="top">
        <a routerLink="/home/communication/activities">
            <h3>Actividades /</h3>
            <div class="breadcrumb">
                <mat-icon svgIcon="arrow back"></mat-icon>
                <h2> {{event.title}}</h2>
            </div>
        </a>
    </div>
</div>
<div class="content form">
    <form [formGroup]="activityForm">
        <h4>Título:</h4>
        <mat-form-field id="title-form-field" appearance="outline"
            [class.mat-form-field-invalid]="activityForm.get('title')?.invalid && activityForm.get('title')?.touched">
            <input type="text" matInput placeholder="Título" formControlName="title">
            @if (activityForm.get('title')?.hasError('required')) {
            <mat-error>
                El título es obligatorio
            </mat-error>
            }
        </mat-form-field>
        <h4>Descripción:</h4>
        <!-- Editor usando variable para la API key -->
        <quill-editor formControlName="description" [modules]="modules" [styles]="{height: '300px'}"></quill-editor>

        @if (activityForm.get('description')?.invalid && activityForm.get('description')?.touched) {
        <div class="error-message">
            La descripción es obligatoria
        </div>
        }

        <div class="dates">
            <h4>Fechas:</h4>
            <!-- Botón para añadir nueva fecha -->
            <button mat-icon-button color="primary" (click)="addNewDate()" class="add-date-button">
                <mat-icon>add</mat-icon>
            </button>
        </div>
        @if (showDateError) {
        <div class="error-message">
            <mat-error>Una fecha mínimo obligatorio</mat-error>
        </div>
        }

        <!-- Sistema de múltiples fechas con @for -->
        @for (day of event.event_days; track day.id) {
        <div class="date-field-container">
            <mat-form-field appearance="outline" style="width: 16%; margin-right: 10px;">
                <mat-label>Fecha</mat-label>
                <input matInput [matDatepicker]="dp" [(ngModel)]="day.date" [ngModelOptions]="{standalone: true}"
                    (dateChange)="onDateChange(day, $event)">
                <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                <mat-datepicker #dp></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline" style="width: 16%; margin-right: 10px;">
                <mat-label>Hora inicio</mat-label>
                <input matInput type="time" [(ngModel)]="day.start_time" [ngModelOptions]="{standalone: true}"
                    (change)="onTimeChange(day, 'start')">
                <mat-icon matSuffix>access_time</mat-icon>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Hora fin</mat-label>
                <input matInput type="time" [(ngModel)]="day.end_time" [ngModelOptions]="{standalone: true}"
                    (change)="onTimeChange(day, 'end')">
                <mat-icon matSuffix>access_time</mat-icon>
            </mat-form-field>

            <button mat-icon-button color="warn" (click)="removeEventDay(day.id)" class="delete-button">
                <mat-icon svgIcon="delete"></mat-icon>
            </button>
        </div>
        }
        <div class="options-row">
            <mat-checkbox [(ngModel)]="event.featured" [ngModelOptions]="{standalone: true}">Destacada</mat-checkbox>
            <mat-checkbox [(ngModel)]="event.scheduled_publication" [ngModelOptions]="{standalone: true}">Programada</mat-checkbox>
            <mat-checkbox [(ngModel)]="event.allow_comments" [ngModelOptions]="{standalone: true}">Permitir comentarios</mat-checkbox>
            <mat-checkbox [(ngModel)]="event.allow_images" [ngModelOptions]="{standalone: true}">Permitir imagenes en comentarios</mat-checkbox>
            <mat-checkbox [(ngModel)]="event.allow_reactions" [ngModelOptions]="{standalone: true}">Permitir reacciones</mat-checkbox>
            <mat-checkbox [(ngModel)]="event.allow_images_direct" [ngModelOptions]="{standalone: true}">Permitir galeria de imágenes</mat-checkbox>
        </div>

        <div class="form-row">
            <h4>Enviar actividad a personal de:</h4>
            <div class="options-row">
                <mat-checkbox [(ngModel)]="event.notification_management" [ngModelOptions]="{standalone: true}">Gestión</mat-checkbox>
                <mat-checkbox [(ngModel)]="event.notification_drivers" [ngModelOptions]="{standalone: true}">Chóferes</mat-checkbox>
            </div>
        </div>

        <br>
        @if (event.scheduled_publication) {
        <br><br>
        <mat-form-field appearance="outline" style="width: 16%; margin-right: 10px;">
            <mat-label>Fecha</mat-label>
            <input matInput [matDatepicker]="datepicker" [(ngModel)]="dateValue" [ngModelOptions]="{standalone: true}">
            <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
            <mat-datepicker #datepicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Hora</mat-label>
            <input matInput type="time" [(ngModel)]="timeValue" [ngModelOptions]="{standalone: true}">
            <mat-icon matSuffix>access_time</mat-icon>
        </mat-form-field>

        <p>Fecha y hora programada: {{getFormattedDateTime()}}</p>
        }

        <h4>Tags:</h4>
        <mat-form-field style="width: 50%;" appearance="outline">
            <input matInput [(ngModel)]="tagNamesString" (blur)="updateTags(tagNamesString)"
                placeholder="Etiquetas separadas por comas" [ngModelOptions]="{standalone: true}">
        </mat-form-field>

        <!-- <h4>Ubicación:</h4>
        <mat-form-field style="width: 50%" appearance="outline">
            <input matInput formControlName="location" placeholder="Ubicación de la actividad" />
        </mat-form-field> -->

        <!-- Fix: Keep registration_link within the form element -->
        <h4>Link:</h4>
        <mat-form-field style="width: 50%" appearance="outline">
            <input matInput formControlName="registration_link" placeholder="ejemplo.com o https://ejemplo.com" />
            @if (activityForm.get('registration_link')?.invalid && activityForm.get('registration_link')?.touched) {
            <mat-error>
                Por favor, ingrese una URL válida (ej: ejemplo.com, https://ejemplo.com)
            </mat-error>
            }
            @if (activityForm.get('registration_link')?.valid && activityForm.get('registration_link')?.value &&
            activityForm.get('registration_link')?.value.trim() !== '') {
            <mat-hint style="color: green;">
                <mat-icon style="font-size: 16px; vertical-align: middle;">check_circle</mat-icon>
                URL válida
            </mat-hint>
            }
            @if (!activityForm.get('registration_link')?.value || activityForm.get('registration_link')?.value.trim()
            === '') {
            <mat-hint>
                Opcional - Enlace para inscripción o más información
            </mat-hint>
            }
        </mat-form-field>
    </form> <!-- Move the form closing tag after the registration_link field -->
    <br>
    <!-- Display current image if available -->
    @if (currentImageUrl && !imageRemoved) {
    <div class="media-header">
        <h4>Imagen actual:</h4>
    </div>
    <div class="existing-media">
        <div class="media-item">
            <div class="image-container">
                <img [src]="currentImageUrl" alt="Imagen de la actividad" class="media-preview">
                <button mat-icon-button color="warn" type="button" (click)="removeImage()" class="delete-image-btn">
                    <mat-icon>delete</mat-icon>
                </button>
            </div>
            <div class="media-info">
                <p>{{(currentImageUrl && currentImageUrl.split('/').pop()) || 'Imagen de la actividad'}}</p>
            </div>
        </div>
    </div>
    } @else {
    <h4>Imagen de la actividad:</h4>
    <!-- Show upload component when no image is present or after image has been removed -->
    <app-upload-files [singleFile]="true" (filesSelected)="onFileSelected($event)"></app-upload-files>
    }

    <div class="buttons">
        <button mat-flat-button id="action" (click)="saveChanges()">Guardar cambios</button>
        <button mat-flat-button id="cancel" routerLink="/home/communication/activities">Cancelar</button>
    </div>
</div>